// State cho module navigation — lưu trữ flag điều hướng tạm thời (ephemeral)
// Module này KHÔNG được persist vào IndexedDB (xem cấu hình reducer trong store.js)
export default {
	// Flag điều hướng từ màn hình Báo cáo Bảng kê
	// Giá trị: null (không có flag) | { reportType: 'summary' | 'detail' }
	bangKeNavigation: null
};
